import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { CLIENT } from "../../Router/paths";
import { axiosInstance } from "../../config/https";
import { toast } from "react-toastify";
import { useLoader, useModal } from "../../context/LoaderContext";

export default function FileAComplainComp() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = () => {
    startLoader();
    const data = {
      title,
      text: message,
      jobpost: id,
    };

    axiosInstance
      .post("/api/disputes/", data)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          openModal(
            "fileAComplain", //gif url
            "Dispute Recorded!", //title
            "Your message is received! Expect prompt assistance as our team is here to help. We appreciate your trust and look forward to ensuring your satisfaction.!" //subtitle
          );
          // toast.success("Dispute Success");
          navigate(CLIENT.jobPost)
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  return (
    <section className="my-jobs pc-p-3">
      <div className="container">
        <div className="primary-heading color-dark mb-4">
          <div className="connects-box">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6 col-6">
                <h4>File A Complain</h4>
              </div>
            </div>
            <div className="row align-items-center mt-2">
              <div className="col-md-12">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  id="title"
                  rows={10}
                  className="form-control mb-2"
                  placeholder="Input Your Dispute Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="message">Message</label>
                <textarea
                  type="text"
                  rows={10}
                  id="message"
                  className="form-control"
                  placeholder="Send Message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
              <div className="col-md-12 text-right">
                <Link
                  to={"#"}
                  onClick={handleSubmit}
                  className="primary-btn primary-bg mt-4"
                >
                  Submit
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
